<template>
    <div id="employeeConfig" style="height:100%;">

        <el-row>
            <el-col :span="24">
                <el-collapse v-model="activeName" style="margin-bottom:15px;">
                    <el-collapse-item title="操作面板" name="1">
                        <div class="t-op__container">
                            <div class="t-op__item">
                                <el-button type="primary" icon="el-icon-circle-plus" @click="handleAdd">添加</el-button>
                            </div>
                            <div class="t-op__item">
                                <el-input placeholder="请输入客户姓名" v-model="search" class="input-with-select">
                                    <el-button slot="append" icon="el-icon-search" @click="loadData"></el-button>
                                </el-input>
                            </div>
                        </div>
                    </el-collapse-item>
                </el-collapse>
            </el-col>
        </el-row>

        <el-row>
            <el-col :span="24">
                <el-table
                        v-loading="loading"
                        :data="tableData"
                        width="100%"
                        :height="tableHeight"
                        stripe>
                    <el-table-column
                            width="80"
                            label="序号"
                            type="index">
                    </el-table-column>
                    <el-table-column
                            show-overflow-tooltip
                            width="260"
                            label="客户名称"
                            prop="customer">
                    </el-table-column>
                    <el-table-column
                            label="创建人"
                            prop="createBy"
                            :formatter="fmtUserId">
                    </el-table-column>
                    <el-table-column
                            label="创建时间"
                            prop="createTime"
                            width="200">
                    </el-table-column>
                    <el-table-column
                            label="修改人"
                            prop="modifyBy"
                            :formatter="fmtUserId">
                    </el-table-column>
                    <el-table-column
                            label="修改时间"
                            prop="modifyTime"
                            width="200">
                    </el-table-column>
                    <el-table-column
                            fixed="right"
                            label="操作"
                            width="100">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="handleEdit(scope.$index, scope.row)">修改
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                        background
                        layout="prev, pager, next"
                        :hide-on-single-page="value"
                        style="padding:10px 0px;"
                        :page-size="pageSize"
                        :total="total"
                        :current-page="pageIndex"
                        @current-change="onCurrentChange">
                </el-pagination>
            </el-col>
        </el-row>

        <el-dialog :title="editItem.title" :width="editItem.width" :visible.sync="editItem.visible">
            <el-form :model="editItem.data">
                <el-form-item label="客户名称" label-width="150px">
                    <el-input v-model="editItem.data.customer" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="editItem.visible = false">取 消</el-button>
                <el-button type="primary" @click="confirm">确 定</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>

    export default {
        name: "CustomerManage",
        data() {
            return {
                tableHeight: window.innerHeight * 0.70,
                activeName: ['1'],
                tableData: [],
                search: '',
                value: true,
                pageIndex: 1,
                pageSize: 20,
                total: 0,
                editItem: {
                    width: '60%',
                    visible: false,
                    title: '客户信息',
                    data: {
                        id: 0,
                        customer: ''
                    },
                    isAdd: false,
                    filter: true,
                    userList: []
                },
                loading:false
            }
        },
        methods: {
            fmtUserId(row, column) {
                let user = this.editItem.userList.find(v => v.id == row.createBy || v.id == row.modifyBy)
                if (user) {
                    return user.name
                }
                return ''
            },
            handleAdd() {
                this.editItem.data = {}
                this.editItem.title = '添加客户信息'
                this.editItem.visible = true
                this.editItem.isAdd = true
            },
            handleEdit(index, row) {
                console.log(index, row);
                this.editItem.title = '编辑客户信息'
                this.editItem.visible = true
                this.editItem.data = row;

                this.editItem.isAdd = false
            },
            loadData() {
                this.loading = true
                this.$store.dispatch("customer/getCustomerWithPage", {
                    pageSize: this.pageSize,
                    pageNum: this.pageIndex,
                    customerName: this.search
                }).then(response => {
                    this.loading = false
                    this.tableData = response.data.data
                    this.total = response.data.total
                })
            },
            addCustomer() {
                this.$store.dispatch("customer/createCustomer", {
                    data: this.editItem.data
                }).then(response => {
                    this.$message({
                        message: response.data.message,
                        type: 'success'
                    })
                    this.editItem.visible = false
                    this.editItem.data = {}
                    this.loadData()
                })
            },
            editCustomer() {
                this.$store.dispatch("customer/saveCustomer", {data: this.editItem.data})
                    .then(response => {
                        this.$message({
                            message: response.data.message,
                            type: 'success'
                        })
                        this.editItem.visible = false
                        this.editItem.data = {}
                        this.loadData()
                    })
            },
            onCurrentChange(page) {
                this.pageIndex = page
                this.loadData()
            },
            confirm() {
                if (this.editItem.isAdd) {
                    this.addCustomer()
                } else {
                    this.editCustomer()
                }
            },
            loadUserList() {
                this.$store.dispatch("employee/getAllUsers")
                    .then(response => {
                        if (response && response.data) {
                            if (response.data.data.length == 0) {
                                this.$message({
                                    message: '没有获取到用户数据',
                                    type: 'error'
                                })
                            }
                            this.editItem.userList = response.data.data
                        }
                    });
            },
        },
        created() {
            this.loadUserList()
        },
        mounted() {
            this.loadData()
        }
    }
</script>

<style lang="scss" scoped>


</style>



// WEBPACK FOOTER //
// customerManage.vue?9a6ca2fa